// extracted by mini-css-extract-plugin
module.exports = {"dialog-assistant":"dialog-assistant___2YYEu","assistantImg":"assistantImg___Kz4aq"};